
  var style = require("icon-maker-loader/.tmp/0a2f764c-24f4-42c4-9868-1a0d858032dd/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-copy"];
  } else {
    module.exports = "icon-maker icon-maker-copy";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/copy.svg
// module id = 537
// module chunks = 5